import { render } from "./TripShipmentTable.vue?vue&type=template&id=d746a026&scoped=true"
import script from "./TripShipmentTable.vue?vue&type=script&lang=js"
export * from "./TripShipmentTable.vue?vue&type=script&lang=js"

import "./TripShipmentTable.vue?vue&type=style&index=0&id=d746a026&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d746a026"]])

export default __exports__